module.exports = __webpack_public_path__ + "img/act.fadd7971.png";